define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaTypeSupply = void 0;
    class WaTypeSupply extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsWateringAtSrf", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsWateringAtSrfError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermissionType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermissionTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrRegulationMethod", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrRegulationMethodError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrMinVolume", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrMinVolumeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrFractionRemaining", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrFractionRemainingError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrStorageType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrStorageTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaterSupplyMethod", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaterSupplyMethodError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfRegulationMethod", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfRegulationMethodError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfMinVolume", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfMinVolumeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfFractionRemaining", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfFractionRemainingError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfOfftakePlacement", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfOfftakePlacementError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfOfftakeSize", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfOfftakeSizeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfTankCapacity", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfTankCapacityError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfStorageType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfStorageTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsElectricityAtWf", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsElectricityAtWfError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfElectricitySrPc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfElectricitySrPcError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfElectricityLoPc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfElectricityLoPcError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaTypeSupply.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.IsWateringAtSrf = (0, EntityUtil_1.toInt)(entity.IsWateringAtSrf);
            a.PermissionType = (0, EntityUtil_1.toInt)(entity.PermissionType);
            a.SrRegulationMethod = (0, EntityUtil_1.toInt)(entity.SrRegulationMethod);
            a.SrMinVolume = (0, EntityUtil_1.toInt)(entity.SrMinVolume);
            a.SrFractionRemaining = (0, EntityUtil_1.toInt)(entity.SrFractionRemaining);
            a.SrStorageType = (0, EntityUtil_1.toInt)(entity.SrStorageType);
            a.WaterSupplyMethod = (0, EntityUtil_1.toInt)(entity.WaterSupplyMethod);
            a.WfRegulationMethod = (0, EntityUtil_1.toInt)(entity.WfRegulationMethod);
            a.WfMinVolume = (0, EntityUtil_1.toInt)(entity.WfMinVolume);
            a.WfFractionRemaining = (0, EntityUtil_1.toInt)(entity.WfFractionRemaining);
            a.WfOfftakePlacement = (0, EntityUtil_1.toFloat)(entity.WfOfftakePlacement);
            a.WfOfftakeSize = (0, EntityUtil_1.toInt)(entity.WfOfftakeSize);
            a.WfTankCapacity = (0, EntityUtil_1.toInt)(entity.WfTankCapacity);
            a.WfStorageType = (0, EntityUtil_1.toInt)(entity.WfStorageType);
            a.IsElectricityAtWf = (0, EntityUtil_1.toInt)(entity.IsElectricityAtWf);
            a.WfElectricitySrPc = (0, EntityUtil_1.toFloat)(entity.WfElectricitySrPc);
            a.WfElectricityLoPc = (0, EntityUtil_1.toFloat)(entity.WfElectricityLoPc);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaTypeSupply.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WaId", "Water Agreement ID");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                IsWateringAtSrf: this.IsWateringAtSrf,
                PermissionType: this.PermissionType,
                SrRegulationMethod: this.SrRegulationMethod,
                SrMinVolume: this.SrMinVolume,
                SrFractionRemaining: this.SrFractionRemaining,
                SrStorageType: this.SrStorageType,
                WaterSupplyMethod: this.WaterSupplyMethod,
                WfRegulationMethod: this.WfRegulationMethod,
                WfMinVolume: this.WfMinVolume,
                WfFractionRemaining: this.WfFractionRemaining,
                WfOfftakePlacement: this.WfOfftakePlacement,
                WfOfftakeSize: this.WfOfftakeSize,
                WfTankCapacity: this.WfTankCapacity,
                WfStorageType: this.WfStorageType,
                IsElectricityAtWf: this.IsElectricityAtWf,
                WfElectricitySrPc: this.WfElectricitySrPc,
                WfElectricityLoPc: this.WfElectricityLoPc,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.WaTypeSupply = WaTypeSupply;
    Object.defineProperty(WaTypeSupply, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaTypeSupply"
    });
    Object.defineProperty(WaTypeSupply, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Landowner Supply Agreement"
    });
    Object.defineProperty(WaTypeSupply, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "IsWateringAtSrf", "PermissionType", "SrRegulationMethod", "SrMinVolume", "SrFractionRemaining", "SrStorageType", "WaterSupplyMethod", "WfRegulationMethod", "WfMinVolume", "WfFractionRemaining", "WfOfftakePlacement", "WfOfftakeSize", "WfTankCapacity", "WfStorageType", "IsElectricityAtWf", "WfElectricitySrPc", "WfElectricityLoPc"]
    });
    Object.defineProperty(WaTypeSupply, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "IsWateringAtSrfTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Will the Landowner be watering their stock at the Stock Route Facility?"
    });
    Object.defineProperty(WaTypeSupply, "IsWateringAtSrfReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "PermissionTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Does the Landholder hold a lease or Permit to Occupy over part of the Network on which the Stock Route Facility is located?"
    });
    Object.defineProperty(WaTypeSupply, "PermissionTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "PermissionTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "SrRegulationMethodTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How will the Stock Route Facility water use be regulated?"
    });
    Object.defineProperty(WaTypeSupply, "SrRegulationMethodDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "SrRegulationMethodReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "SrMinVolumeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the minimum volume of water required for travelling stock?"
    });
    Object.defineProperty(WaTypeSupply, "SrMinVolumeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "SrFractionRemainingTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What fraction of the water storage must always remain available?"
    });
    Object.defineProperty(WaTypeSupply, "SrFractionRemainingDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "SrFractionRemainingReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "SrStorageTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What type of storage does the Stock Route Facility have?"
    });
    Object.defineProperty(WaTypeSupply, "SrStorageTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "SrStorageTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WaterSupplyMethodTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How is water being supplied to the Stock Route Facility?"
    });
    Object.defineProperty(WaTypeSupply, "WaterSupplyMethodDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "WaterSupplyMethodReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfRegulationMethodTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How will the piped water use be regulated?"
    });
    Object.defineProperty(WaTypeSupply, "WfRegulationMethodDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "WfRegulationMethodReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfMinVolumeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the minimum volume (in litres) of water required for the Landowner’s stock?"
    });
    Object.defineProperty(WaTypeSupply, "WfMinVolumeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfFractionRemainingTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What fraction of the Water Facility’s water storage must always remain available?"
    });
    Object.defineProperty(WaTypeSupply, "WfFractionRemainingDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "WfFractionRemainingReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfOfftakePlacementTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What distance (in metres) from the top of the water storage must the offtake be placed?"
    });
    Object.defineProperty(WaTypeSupply, "WfOfftakePlacementReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfOfftakeSizeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Maximum offtake pipe diameter (in millimetres)"
    });
    Object.defineProperty(WaTypeSupply, "WfOfftakeSizeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfTankCapacityTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Maximum capacity (in litres) of the Stock Route Facility water tank in litres"
    });
    Object.defineProperty(WaTypeSupply, "WfTankCapacityReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfStorageTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What type of storage does the Water Facility have?"
    });
    Object.defineProperty(WaTypeSupply, "WfStorageTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSupply, "WfStorageTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "IsElectricityAtWfTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Is electricity connected or required at the Water Facility?"
    });
    Object.defineProperty(WaTypeSupply, "IsElectricityAtWfReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfElectricitySrPcTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the percentage of the water supplied by the Water Facility that is used by travelling stock?"
    });
    Object.defineProperty(WaTypeSupply, "WfElectricitySrPcReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSupply, "WfElectricityLoPcTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the percentage of the water supplied by the stock route facility that is used by the landowner? E.g. if travelling stock only use 10% of the water supplied by the stock route facility, then 90% is used by the Landowner"
    });
    Object.defineProperty(WaTypeSupply, "WfElectricityLoPcReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "IsWateringAtSrf", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "IsWateringAtSrfError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "PermissionType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "PermissionTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "SrRegulationMethod", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "SrRegulationMethodError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "SrMinVolume", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "SrMinVolumeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "SrFractionRemaining", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "SrFractionRemainingError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "SrStorageType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "SrStorageTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WaterSupplyMethod", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WaterSupplyMethodError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfRegulationMethod", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfRegulationMethodError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfMinVolume", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfMinVolumeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfFractionRemaining", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfFractionRemainingError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfOfftakePlacement", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfOfftakePlacementError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfOfftakeSize", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfOfftakeSizeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfTankCapacity", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfTankCapacityError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfStorageType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfStorageTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "IsElectricityAtWf", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "IsElectricityAtWfError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfElectricitySrPc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfElectricitySrPcError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfElectricityLoPc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "WfElectricityLoPcError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSupply.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSupply.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSupply.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSupply.prototype, "merge", null);
});
